import React, { useState, useEffect } from "react";
import { Icon, Card, Row, Col, Tooltip,Carousel,Table } from "antd";
import moment from "moment";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import Search from "../../components/table/search";
import SearchDates from "../../components/table/searchDates";
import ModalDesingProcess from "../../components/modal-desing-process";
import RenderDesingProcessData from "../../components/render-desing-process-data";
import EjeFinal from "../../img/Eje-Final.jpg";
import RuedaFinal from "../../img/Rueda-Final.jpg";
import EjeInicial from "../../img/Eje-Inicial.jpg";
import RuedaInicial from "../../img/Rueda-Inicial.jpg";
import EjeInferior from "../../img/Eje-Herramienta-Inferior.jpg";
import RuedaInferior from "../../img/Rueda-Herramienta-Inferior.jpg";
import EjeSuperior from "../../img/Eje-Herramienta-Superior.jpg";
import RuedaSuperior from "../../img/Rueda-Herramienta-Superior.jpg";
import useProcessDesings from "../../hooks/useProcessDesings";
import useManufacturingOrder from "../../hooks/useManufacturingOrder";
import { useTranslation } from 'react-i18next';

const ListDesingProcess = ({ changeTitle }) => {
  const [listOfProcessDesing, setListOfProcessDesing] = useState([]);
  const [selectedProcessDesing, setSelectedProcessDesing] = useState(null);
  const [selectedRowKey, setSelectedRowKey] = useState([]);
  const [showModalDesing, setShowModalDesing] = useState(false);
  const { processDesings } = useProcessDesings();
  const { getOrderWithDesings } = useManufacturingOrder();

  const contentStyle = {
    height: '160px',
    color: '#fff',
    lineHeight: '160px',
    textAlign: 'center',
    background: '#FFFFFF'
  }

  const SampleNextArrow = props => {
    const { className, style, onClick } = props
    return (
      <div
        className={className}
        style={{
          ...style,
          color: 'rgba(255, 255, 255, .0)',
          fontSize: '30px',
          marginRight:'2%'
        }}
        onClick={onClick}
      >
        <RightOutlined style={{color:'black'}}/>
      </div>
    )
  }
  
  const SamplePrevArrow = props => {
    const { className, onClick } = props
    return (
      <div
        className={className}
        style={{
          color: 'rgba(255, 255, 255, .0)',
          fontSize: '30px'
        }}
        onClick={onClick}
      >
        <LeftOutlined style={{color:'black'}}/>
      </div>
    )
  }
  
  const settings = {
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    dots:false,
    Infinite:true,
    spedd:100
  }

  const { t } = useTranslation();

  useEffect(() => {
    changeTitle && changeTitle("designs");
  }, [changeTitle]);

  useEffect(() => {
    const normalized = processDesings.map(design => {
      return {
        key: design.id,
        inUse: getOrderWithDesings().includes(design.id),
        ...design
      };
    });

    normalized && setListOfProcessDesing(normalized);
    if (normalized && normalized[0]) {
      setSelectedProcessDesing(normalized[0]);
      setSelectedRowKey([normalized[0].key]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processDesings]);

  const handleShowModalDesing = visible => setShowModalDesing(visible);

  const columns = [
    {
      title: t('table.header.name'),
      dataIndex: "desingName",
      key: "desingName",
      width: 130,
      fixed: 'left',
      sorter: (a, b) => a.desingName.localeCompare(b.desingName),
      defaultSortOrder: "ascend",
      ...Search("desingName")
    },
    {
      title: t('table.header.article'),
      dataIndex: "article.articleName",
      key: "articleName",
      width: 115,
      sorter: (a, b) => a.article.articleName.localeCompare(b.article.articleName),
      defaultSortOrder: "descend"
    },
    {
      title: t('table.header.geometryFin'),
      dataIndex: "article.geometriaFinal",
      key: "geometriaFinal",
      width: 200,
      sorter: (a, b) => a.article.geometriaFinal.localeCompare(b.article.geometriaFinal),
      defaultSortOrder: "descend",
      ...Search("geometriaFinal")
    },
    {
      title: t('table.header.geometryIni'),
      dataIndex: "article.geometriaInicial",
      key: "geometriaInicial",
      width: 200,
      sorter: (a, b) => a.article.geometriaInicial.localeCompare(b.article.geometriaInicial),
      defaultSortOrder: "descend",
      ...Search("geometriaInicial")
    },
    {
      title: t('table.header.toolTop'),
      dataIndex: "article.herramientaSuperior",
      key: "herramientaSuperior",
      width: 220,
      sorter: (a, b) => a.article.herramientaSuperior.localeCompare(b.article.herramientaSuperior),
      defaultSortOrder: "descend",
      ...Search("herramientaSuperior")
    },
    {
      title: t('table.header.toolBot'),
      dataIndex: "article.herramientaInferior",
      key: "herramientaInferior",
      width: 200,
      sorter: (a, b) => a.article.herramientaInferior.localeCompare(b.article.herramientaInferior),
      defaultSortOrder: "descend",
      ...Search("herramientaInferior")
    },
    {
      title: t('table.header.design_date'),
      dataIndex: "date",
      key: "date",
      width: 200,
      sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(),
      ...SearchDates("date"),
      render: date => moment(date).format("DD/MM/YYYY HH:mm:ss")
    },
    {
      title: t('table.header.actions'),
      key: "action",
      width: 90,
      fixed: 'right',
      render: (text, record) => (
        <Row type="flex" justify="space-between">
          <Tooltip>
            <Icon type="edit" style={{ color: "#ccc" }} />
          </Tooltip>

          <Tooltip>
            <Icon type="delete" style={{ color: "#ccc"}} />
          </Tooltip>
        </Row>
      )
    }
  ];

  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKey(selectedRowKeys);
    },
    onSelect: (record, selected, selectedRows) => {
      const processDesing = processDesings.find(obj => obj.id === record.id)
      setSelectedProcessDesing(processDesing);
    },
    type: "radio",
    fixed:true,
    columnWidth:50
  };

  const clickRow = row => {
    setSelectedRowKey([row.key]);
    const processDesing = processDesings.find(obj => obj.id === row.id)
    setSelectedProcessDesing(processDesing);
  };

  return (
    <Row style={{ margin: 0 }} gutter={[16, 16]}>
      <Col xl={16} lg={24}>
        <Table
          bordered
          dataSource={listOfProcessDesing}
          columns={columns}
          rowSelection={rowSelection}
          scroll={{ x: true, y: true }}
          bodyStyle={{ backgroundColor: "White" }}
          onClick={() => clickRow}
        />
      </Col>
      <Col xl={8} lg={24}>
        <Card
          title={selectedProcessDesing && selectedProcessDesing.desingName}
        >
          <Carousel arrows {...settings} style={{marginBottom:20}}>
            <div>
              <h3 style={contentStyle}>
                <img
                  alt="Pieza1"
                  style={{ width: 292, height: 182,marginLeft:'12vh',marginTop:'1vh'}}
                  src={selectedProcessDesing && selectedProcessDesing.article && selectedProcessDesing.article.figure === "eje" ?EjeFinal:RuedaFinal}
                />
              </h3>
            </div>
            <div>
              <h3 style={contentStyle}>
                <img
                  alt="Pieza0"
                  style={{ width: 110, height: 142,marginLeft:'21vh',marginTop:'3vh'}}
                  src={selectedProcessDesing && selectedProcessDesing.article && selectedProcessDesing.article.figure === "eje" ?EjeInicial:RuedaInicial}
                />
              </h3>
            </div>
            <div>
              <h3 style={contentStyle}>
                <img
                  alt="Pieza2"
                  style={{ width: 110, height: 142,marginLeft:'21vh',marginTop:'3vh'}}
                  src={selectedProcessDesing && selectedProcessDesing.article && selectedProcessDesing.article.figure === "eje" ?EjeSuperior:RuedaSuperior}
                />
              </h3>
            </div>
            <div>
              <h3 style={contentStyle}>
                <img
                  alt="Pieza3"
                  style={{ width: 110, height: 142,marginLeft:'21vh',marginTop:'3vh'}}
                  src={selectedProcessDesing && selectedProcessDesing.article && selectedProcessDesing.article.figure === "eje" ?EjeInferior:RuedaInferior}
                />
              </h3>
            </div>
          </Carousel>
          {/*Datos de la derecha*/}
          <RenderDesingProcessData selectedProcessDesing={selectedProcessDesing} setModal={() => setShowModalDesing(true)} isFisrt={true}/>
        </Card>
      </Col>
      {/*Datos -ver mas informacion-*/}
      <ModalDesingProcess visible={showModalDesing} handleVisible={handleShowModalDesing} desing={selectedProcessDesing} />
    </Row>
  );
};

export default ListDesingProcess;
